import store from 'src/js/store';
import actions from 'src/js/modules/context-menu/actions';

function hideContextMenu() {
  store.dispatch(actions.hideContextMenu());
}

export default hideContextMenu;
